import { SectionSubTitle } from "../../../components/SectionTitle";
import { Spacer } from "../../../components/Spacer";
import { FadeLeft } from "../../../components/Transitions/FadeLeft";

export const Transfers = () => {
  return (
    <FadeLeft>
      <SectionSubTitle title="Información sobre autobuses" />

      <Spacer />
      <Spacer />

      <div className="text-primary-text max-w-2xl m-auto rounded-4xl  border border-primary-text/10 shadow-soft">
        <div className="border-8 border-white rounded-4xl p-6 md:p-8">
          <div className="text-xl md:text-2xl font-light pb-2">Salidas</div>
          <ul className="space-y-2 text-lg md:text-xl opacity-75">
            <li>
              <span className="eyebrow-md opacity-80">13:30</span> - Desde Plaza
              Ponce de León (Junto a la iglesia)
            </li>
          </ul>

          <div className="text-xl md:text-2xl font-light mt-6 pb-2">
            Regresos
          </div>
          <ul className="space-y-2 text-lg md:text-xl opacity-75">
            <li>
              <span className="eyebrow-md opacity-80">21:30</span> - A Plaza
              Ponce de León
            </li>
            <li>
              <span className="eyebrow-md opacity-80">23:00</span> - A Plaza
              Ponce de León
            </li>
            <li>
              <span className="eyebrow-md opacity-80">01:00</span> - A Plaza
              Ponce de León
            </li>
          </ul>
        </div>
      </div>
    </FadeLeft>
  );
};
